<main id="otp" class="w-screen flex flex-col justify-center">
  <div class=" max-w-sm mx-auto white-card">
    <div class="header-wr">
      <img class="mx-auto company-logo" src="../../../../../assets/logos/aricoma-dark.svg" [attr.alt]="'LOGIN.LOGO_ALT' | translate" (click)="backToLogin()">
      <h2 class="text-left">{{ 'OTP.SETUP_TITLE' | translate }}</h2>
    </div>
    <div class="form-wr">
      <form (keydown)="submitOnPressEnter($event)">
        <div class="notice text-sm mb-6">
          <p>{{ 'OTP.OTP_SETUP_HINT' | translate }}</p>
        </div>
        @if (qrData) {
          <div class="qr-wr mt-8 mb-4 text-center">
            <div class="flex flex-col align-items-center">
              <qrcode #qrCodeEl [qrdata]="qrData" [width]="128" [errorCorrectionLevel]="'M'"></qrcode>
              <span class="text-sm font-semibold mt-3 block">{{ 'OTP.OTP_KEY' | translate }}</span>
              <div class="otp-key-wrapper">
                <code class="otp-key">{{ mfaConfigKey }}</code>
                <button type="button" class="copy-btn" (click)="copyMfaKey()">{{ 'OTP.BTN_COPY' | translate }}</button>
              </div>
            </div>
          </div>
        }
        <div class="field-wr">
          <div class="flex items-center justify-between">
            <label for="verification-code" class="block text-sm">{{ 'OTP.VERIFICATION_CODE' | translate }}</label>
          </div>
          <div class="mt-2">
            <input id="verification-code" type="text" name="verification-code" placeholder="{{ 'OTP.VERIFICATION_CODE_PLACEHOLDER' | translate }}" maxlength="6" [(ngModel)]="verificationCode" required  autocomplete="off" class="text-field">
          </div>
        </div>
        <div class="btn-wr mt-5">
          <button type="button" id="otp-verify-btn" class="btn primary-btn w-full" (click)="verify()">{{ 'OTP.BTN_VERIFY' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</main>

